import Vue from "vue";
import Vuetify from "vuetify/lib";

Vue.use(Vuetify);

import pl from "vuetify/src/locale/pl.ts";

export default new Vuetify({
  lang: {
    locales: { pl },
    current: "pl"
  }
});
